
  <img src="../../../assets/img/logo-fsb-positivo.png" alt="" id="logo-login">
  <div id="formLogin">
    <po-container p-noBorder="true">
      <form class="po-form" [formGroup]="loginForm" (keyup.enter)="login(loginForm.value)">
        <po-login class="po-sm-12 po-md-12 po-xl-12" p-mask="99.999.999/9999-99" p-required="true"
          p-placeholder="Insira o CNPJ da empresa" formControlName="empresa" p-label="Empresa"
          p-help="Informar o CNPJ da empresa do Grupo FSB para qual emitiu a nota fiscal"></po-login>
        <po-input class="po-sm-12 po-md-12 po-xl-12" p-required="true" formControlName="username" p-label="Usuário"
          p-placeholder="99999999999999" p-mask="99999999999999" p-help="Informar o  CNPJ – de sua empresa">
        </po-input>
        <po-password class="po-sm-12 po-md-12 po-xl-12" p-required="true" p-placeholder="Insira sua senha de acesso"
          formControlName="password" p-label="Senha"
          p-help="Informar a senha –  atenção lembre-se caso você já tenha alterado"></po-password>

        <po-button class="po-xl-12" p-label="Login" (p-click)="login(loginForm.value)"
          [p-disabled]="loginForm.invalid"></po-button>
        <a href="#" (click)="passwordRecoverModal.open()">Recuperar senha</a>
      </form>
    </po-container>
  </div>




  <section class="container po-row po-font-text">
    <p class="po-font-text" id="copyright">Desenvolvido por
      <a href="http://www.mustti.com.br/" target="_blank">
        <img alt="Logo MUSTTI" src="../../../assets/img/logo-mustti.png">
      </a>
    </p>
    <p class="po-font-text">Em caso de dúvida entrar em contato através do email:
      <span><a href="mailto:fornecedores@fsbholding.com.br "
          class="primary-color link-email">fornecedores@fsbholding.com.br</a></span>
    </p>
  </section>



<po-modal #modalErrorLogin [p-hide-close]="true">
  <div>
    <span class="color-modal-content-error-sub-titulo"> {{this.subTitleModalError}} <span class="color-modal-content-error">{{this.contentModalError}}</span> </span>
  </div>
</po-modal>


<po-modal #passwordRecoverModal p-title="Recuperar senha">
  <p>Digite o CNPJ abaixo e você receberá por e-mail as instruções para recuperação da senha.</p>
  <br>
  <form [formGroup]="passwordRecoverForm">
    <po-input formControlName="cnpj" p-label="CNPJ" p-placeholder="99.999.999/9999-99" p-mask="99.999.999/9999-99">
    </po-input>
    <po-button [p-disabled]="passwordRecoverForm.invalid" p-label="Enviar"
      (p-click)="passwordRecover(passwordRecoverForm.value)"></po-button>
  </form>
</po-modal>

<po-modal #empresaModal class="limitModal" p-title="Selecione uma empresa" [p-primary-action]="confirm" p-size="auto"
  p-hide-close="true" p-click-out="boolean">
  <po-table p-hide-columns-manager="true" [p-columns]="tableEmpresasColumns" [p-items]="tableEmpresasItems"
    p-sort="true" p-striped="true" p-selectable="true" p-single-select="true" (p-selected)="selected($event)"
    (p-unselected)="unSelected($event)">
  </po-table>
</po-modal>

<po-modal #lgpdModal class="lgpdModal" p-title="" [p-primary-action]="aceitarLgpd" [p-secondary-action]="recusarLgpd"
  p-size="small" p-hide-close="true" p-click-out="boolean">
  <div [innerHTML]="htmlSafeLgpd | safeHtml"></div>
</po-modal>

<po-modal #lgpdRecusaModal class="lgpdModal lgpdModalRecusa" [p-title]="" [p-primary-action]="recusarLgpdPrimary"
  [p-secondary-action]="recusarLgpdSecondary" p-size="small" p-hide-close="false" p-click-out="boolean">
  <div [innerHTML]="htmlSafeLgpdRecusa | safeHtml"></div>
</po-modal>

<po-loading-overlay *ngIf="loading" p-screen-lock="true" p-text="Carregando">
</po-loading-overlay>
